import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ToastrService from '@/shared/services/ToastrService';
import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '@/shared/components/OkCancelModal';
import EnumSelect from '@/shared/components/input/EnumSelect';
import messages from '../documentMessages';

export default class ChangeSigningStatusModal extends Component {
  state = {
    signingStatus: undefined,
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  onSave = () => {
    const { signingStatus } = this.state;
    const { onSave, intl } = this.props;
    if (!signingStatus) {
      return onSave({ signingStatus: null });
    }
    return onSave({ signingStatus });
  };

  closeModal = () => {
    const { onClose } = this.props;
    onClose();
  };

  render() {
    const { show, intl } = this.props;
    const { documentDate, dateFocused } = this.state;
    if (!show) return null;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.ChangeSigningStatus)}
        show={show}
        onClose={this.closeModal}
        disabled={false}
        onSave={() => this.onSave()}
      >
        <div className="form-horizontal">
          <div>
            <div className="form-group">
              <label className="control-label col-md-5">
                <FormattedMessage {...messages.SigningStatus} />
              </label>
              <div className="col-md-7">
                <EnumSelect
                  allowNull={true}
                  nullLabel=" "
                  enumType="signingStatus"
                  onChange={val => this.setState({ signingStatus: val })}
                  hideItems={[3, 4, 11, 12, 21]}
                />
              </div>
            </div>
          </div>
        </div>
      </OkCancelModal>
    );
  }
}
